import { MantineTheme } from "@mantine/core";

export const sharedSelectStyles = (theme: MantineTheme) => ({
  input: {
    "&.mantine-select-input": {
      borderRadius: "0.25rem",
      border: "1px solid #ced4da",
      "&:focus": {
        borderColor: theme.colors.blue[5],
      },
    },
  },
  wrapper: {
    width: "100%",
  },
});